import { USD, RUB, EUR } from 'constants/currency'

export function calcRateInCurrentCurrency(
  projectRate,
  projectCurrencyType,
  currentCurrency
) {
  if (currentCurrency.type === projectCurrencyType) return projectRate

  const fromDialyRate =
    projectCurrencyType === USD
      ? currentCurrency.usdRate
      : projectCurrencyType === EUR
      ? currentCurrency.eurRate
      : 1
  const toDialyRate =
    currentCurrency.type === USD
      ? currentCurrency.usdRate
      : currentCurrency.type === EUR
      ? currentCurrency.eurRate
      : 1
  const rate = fromDialyRate / toDialyRate

  return currentCurrency.type === RUB
    ? +(projectRate / rate).toFixed(0)
    : +(projectRate / rate).toFixed(1)
}

export function getCurrency() {
  return localStorage.getItem('currency')
}

export function setCurrency(newCurrency) {
  return localStorage.setItem('currency', newCurrency)
}
